import React, { useState, useRef, useEffect } from 'react';

export default function useHover<T extends HTMLElement>(): [React.RefObject<T>, boolean] {
  const [hover, setHover] = useState(false);
  const ref = useRef<T>(null);

  const handleMouseEnter = () => setHover(true);
  const handleMouseLeave = () => setHover(false);

  useEffect(() => {
    const node = ref.current;
    if (node) {
      node.addEventListener('mouseenter', handleMouseEnter);
      node.addEventListener('mouseleave', handleMouseLeave);
      return () => {
        node.removeEventListener('mouseenter', handleMouseEnter);
        node.removeEventListener('mouseleave', handleMouseLeave);
      };
    }
  }, []);

  return [ref, hover];
}
